import {
  activeColumns as historyInitialActiveColumns,
  Columns as HistoryColumns,
  OrderValue as HistoryOrderValue,
  sortableColumns as historySortableColumns,
} from 'pages/mentor/mentorship/management/mentees/history';
import { List } from 'store/actions/mentor/menteeLists';
import ActionTypes from 'store/actionTypes/mentor/menteeLists';
import { ListState } from 'store/reducers/types';
import { updateObject } from 'store/updateObject';
import {
  isNumberAction,
  isOrderAction,
  isStringAction,
  TypedAction,
} from 'types/typeguards/reducerActions';

const historyTagColumns = [] as const;
type HistoryTagColumns = typeof historyTagColumns[number];

export type MenteeListsState = {
  history: ListState<HistoryTagColumns, HistoryColumns, HistoryOrderValue>;
};

const initialState: MenteeListsState = {
  history: {
    page: 0,
    tags: {},
    search: '',
    activeColumns: historyInitialActiveColumns,
    take: 100,
    order: 'desc/updatedAt',
  },
};

const setPage = (
  list: List,
  state: MenteeListsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      page: action.value,
    }),
  });
};

const setSearch = (
  list: List,
  state: MenteeListsState,
  action: TypedAction<string>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      search: action.value,
      page: 0,
    }),
  });
};

const setOrderHistory = (
  state: MenteeListsState,
  action: TypedAction<HistoryOrderValue>,
) => {
  return updateObject(state, {
    history: updateObject(state.history, {
      order: action.value,
      page: 0,
    }),
  });
};

const menteeListsReducer = (
  state = initialState,
  action: { type: string; value: unknown },
) => {
  switch (action.type) {
    case ActionTypes.HISTORY_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('history', state, action);
      }
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.HISTORY_SET_SEARCH:
      if (isStringAction(action)) {
        return setSearch('history', state, action);
      }
      console.log('Action type error: setSearch');
      return state;
    default:
      return state;

    case ActionTypes.HISTORY_SET_ORDER:
      if (isOrderAction(historySortableColumns, action)) {
        return setOrderHistory(state, action);
      }
      console.log('Action type error: setTake');
      return state;
  }
};

export default menteeListsReducer;
